import { IconCalendarEvent as TablerIconCalendarEvent } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconCalendarEvent = /*#__PURE__*/ createOutlineIcon(
  TablerIconCalendarEvent,
  'IconCalendarEvent',
);
